import type { ItemDefInput } from '../../schemas/items';

/**
 * Shop stock (docs/design/content-items.md §A). Prices are per unit: buyPrice = "Nhập/đv", sellPrice = "Bán/đv";
 * stock is bought in boxes of 4. Products only live in the bag or on Minimart surfaces, never in Home.
 */
export const PRODUCTS = [
  // ---- khởi đầu (unl_minimart) ----
  {
    id: 'prod_instant_noodle',
    kind: 'product',
    nameKey: 'item.prod_instant_noodle.name',
    loreKey: 'item.prod_instant_noodle.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['noodle'],
    themeTags: ['office'],
    unlockId: 'unl_minimart',
    buyPrice: 7,
    sellPrice: 11,
    material: 'paper',
    sources: [{ kind: 'catalog' }, { kind: 'starter', boxId: 'box_06_shop' }],
    sprite: { frame: 'item_prod_instant_noodle' },
  },
  {
    id: 'prod_canned_coffee',
    kind: 'product',
    nameKey: 'item.prod_canned_coffee.name',
    loreKey: 'item.prod_canned_coffee.lore',
    shopTab: 'stock',
    productCategory: 'drink',
    layer: 'surface',
    rotations: 1,
    tags: ['coffee'],
    themeTags: ['office'],
    unlockId: 'unl_minimart',
    buyPrice: 11,
    sellPrice: 16,
    material: 'metal',
    sources: [{ kind: 'catalog' }, { kind: 'starter', boxId: 'box_06_shop' }],
    sprite: { frame: 'item_prod_canned_coffee' },
  },
  {
    id: 'prod_milk_tea',
    kind: 'product',
    nameKey: 'item.prod_milk_tea.name',
    loreKey: 'item.prod_milk_tea.lore',
    shopTab: 'stock',
    productCategory: 'drink',
    layer: 'surface',
    rotations: 1,
    tags: ['tea'],
    themeTags: ['sweet', 'cute'],
    unlockId: 'unl_minimart',
    buyPrice: 13,
    sellPrice: 20,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_milk_tea' },
  },
  {
    id: 'prod_cookie_box',
    kind: 'product',
    nameKey: 'item.prod_cookie_box.name',
    loreKey: 'item.prod_cookie_box.lore',
    shopTab: 'stock',
    productCategory: 'snack',
    layer: 'surface',
    rotations: 1,
    tags: ['cookie'],
    themeTags: ['sweet'],
    unlockId: 'unl_minimart',
    buyPrice: 16,
    sellPrice: 24,
    material: 'metal',
    sources: [{ kind: 'catalog' }, { kind: 'starter', boxId: 'box_06_shop' }],
    sprite: { frame: 'item_prod_cookie_box' },
  },
  {
    id: 'prod_candy_jar',
    kind: 'product',
    nameKey: 'item.prod_candy_jar.name',
    loreKey: 'item.prod_candy_jar.lore',
    shopTab: 'stock',
    productCategory: 'snack',
    layer: 'surface',
    rotations: 1,
    tags: ['candy'],
    themeTags: ['sweet', 'kids'],
    unlockId: 'unl_minimart',
    buyPrice: 8,
    sellPrice: 12,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_candy_jar' },
  },

  // ---- t2 (unl_products_t2) ----
  {
    id: 'prod_sticker_pack',
    kind: 'product',
    nameKey: 'item.prod_sticker_pack.name',
    loreKey: 'item.prod_sticker_pack.lore',
    shopTab: 'stock',
    productCategory: 'stationery',
    layer: 'surface',
    rotations: 1,
    tags: ['sticker'],
    themeTags: ['kids', 'cute'],
    unlockId: 'unl_products_t2',
    buyPrice: 9,
    sellPrice: 15,
    material: 'paper',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_sticker_pack' },
  },
  {
    id: 'prod_pastel_notebook',
    kind: 'product',
    nameKey: 'item.prod_pastel_notebook.name',
    loreKey: 'item.prod_pastel_notebook.lore',
    shopTab: 'stock',
    productCategory: 'stationery',
    layer: 'surface',
    rotations: 1,
    tags: ['notebook'],
    themeTags: ['office', 'cute'],
    unlockId: 'unl_products_t2',
    buyPrice: 19,
    sellPrice: 28,
    material: 'paper',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_pastel_notebook' },
  },
  {
    id: 'prod_gel_pens',
    kind: 'product',
    nameKey: 'item.prod_gel_pens.name',
    loreKey: 'item.prod_gel_pens.lore',
    shopTab: 'stock',
    productCategory: 'stationery',
    layer: 'surface',
    rotations: 1,
    tags: ['pen'],
    themeTags: ['office', 'kids'],
    unlockId: 'unl_products_t2',
    buyPrice: 12,
    sellPrice: 19,
    material: 'box',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_gel_pens' },
  },
  {
    id: 'prod_green_tea',
    kind: 'product',
    nameKey: 'item.prod_green_tea.name',
    loreKey: 'item.prod_green_tea.lore',
    shopTab: 'stock',
    productCategory: 'drink',
    layer: 'surface',
    rotations: 1,
    tags: ['tea'],
    themeTags: ['healthy'],
    unlockId: 'unl_products_t2',
    buyPrice: 15,
    sellPrice: 21,
    material: 'box',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_green_tea' },
  },
  {
    id: 'prod_cat_pate',
    kind: 'product',
    nameKey: 'item.prod_cat_pate.name',
    loreKey: 'item.prod_cat_pate.lore',
    shopTab: 'stock',
    productCategory: 'pet',
    layer: 'surface',
    rotations: 1,
    tags: ['cat_food'],
    themeTags: ['pet'],
    unlockId: 'unl_products_t2',
    buyPrice: 13,
    sellPrice: 20,
    material: 'metal',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_cat_pate' },
  },

  // ---- t3 (unl_products_t3) ----
  {
    id: 'prod_fruit_basket',
    kind: 'product',
    nameKey: 'item.prod_fruit_basket.name',
    loreKey: 'item.prod_fruit_basket.lore',
    shopTab: 'stock',
    productCategory: 'fruit',
    layer: 'surface',
    rotations: 1,
    tags: ['fruit'],
    homeTags: ['on:basket'],
    themeTags: ['healthy'],
    unlockId: 'unl_products_t3',
    buyPrice: 24,
    sellPrice: 36,
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_fruit_basket' },
  },
  {
    id: 'prod_strawberry_jam',
    kind: 'product',
    nameKey: 'item.prod_strawberry_jam.name',
    loreKey: 'item.prod_strawberry_jam.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['jam'],
    themeTags: ['sweet', 'cozy'],
    unlockId: 'unl_products_t3',
    buyPrice: 20,
    sellPrice: 31,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_strawberry_jam' },
  },
  {
    id: 'prod_honey_jar',
    kind: 'product',
    nameKey: 'item.prod_honey_jar.name',
    loreKey: 'item.prod_honey_jar.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['honey'],
    themeTags: ['healthy', 'cozy'],
    unlockId: 'unl_products_t3',
    buyPrice: 25,
    sellPrice: 38,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_honey_jar' },
  },
  {
    id: 'prod_seed_packet',
    kind: 'product',
    nameKey: 'item.prod_seed_packet.name',
    loreKey: 'item.prod_seed_packet.lore',
    shopTab: 'stock',
    productCategory: 'garden',
    layer: 'surface',
    rotations: 1,
    tags: ['seed'],
    themeTags: ['garden'],
    unlockId: 'unl_products_t3',
    buyPrice: 11,
    sellPrice: 16,
    material: 'paper',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_seed_packet' },
  },
  {
    id: 'prod_scented_candle',
    kind: 'product',
    nameKey: 'item.prod_scented_candle.name',
    loreKey: 'item.prod_scented_candle.lore',
    shopTab: 'stock',
    productCategory: 'home',
    layer: 'surface',
    rotations: 1,
    tags: ['candle'],
    themeTags: ['cozy', 'cute'],
    unlockId: 'unl_products_t3',
    buyPrice: 25,
    sellPrice: 38,
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_prod_scented_candle' },
  },
  // ---- Hàng nhà làm (minigames.md §4.11): cooked in Bếp của bà, never sold in the catalog ----
  {
    id: 'prod_home_jam',
    kind: 'product',
    nameKey: 'item.prod_home_jam.name',
    loreKey: 'item.prod_home_jam.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['jam', 'homemade'],
    themeTags: ['sweet', 'cozy'],
    unlockId: 'unl_cooking',
    buyPrice: 20,
    sellPrice: 34,
    material: 'glass',
    sources: [{ kind: 'reward', ref: 'mg_cooking_l1' }],
    sprite: { frame: 'item_prod_home_jam' },
  },
  {
    id: 'prod_home_noodle',
    kind: 'product',
    nameKey: 'item.prod_home_noodle.name',
    loreKey: 'item.prod_home_noodle.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['noodle', 'homemade'],
    themeTags: ['office', 'cozy'],
    unlockId: 'unl_cooking',
    buyPrice: 17,
    sellPrice: 30,
    material: 'paper',
    sources: [{ kind: 'reward', ref: 'mg_cooking_l2' }],
    sprite: { frame: 'item_prod_home_noodle' },
  },
  {
    id: 'prod_home_kimbap',
    kind: 'product',
    nameKey: 'item.prod_home_kimbap.name',
    loreKey: 'item.prod_home_kimbap.lore',
    shopTab: 'stock',
    productCategory: 'food',
    layer: 'surface',
    rotations: 1,
    tags: ['kimbap', 'homemade'],
    themeTags: ['kids', 'healthy'],
    unlockId: 'unl_cooking',
    buyPrice: 22,
    sellPrice: 38,
    material: 'box',
    sources: [{ kind: 'reward', ref: 'mg_cooking_l3' }],
    sprite: { frame: 'item_prod_home_kimbap' },
  },
] as const satisfies readonly ItemDefInput[];
